import React, { ReactElement } from 'react';
import { Box } from '@mui/material';
import { GeneratedExtensionIcon } from 'components/common/gallery/fileExtensions/generatedExtensionIcon';
import { THUMBNAIL_ERROR_CONTAINER_SX } from '../styles';

interface ThumbnailErrorFallbackProps {
  onClick: (e: React.SyntheticEvent) => void;
  fileType: string;
  fileExtension?: string;
}

export const ThumbnailErrorFallback: React.FC<
  ThumbnailErrorFallbackProps
> = ({ onClick, fileType, fileExtension }): ReactElement => {
  return (
    <Box onClick={onClick} sx={THUMBNAIL_ERROR_CONTAINER_SX}>
      <GeneratedExtensionIcon
        fileType={fileType}
        fileExtension={fileExtension}
        size={48}
      />
    </Box>
  );
};
